import React, { useState, useEffect } from 'react';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import { Line } from 'react-chartjs-2';

// Register the components once
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const Graph = () => {

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        fetch('https://frankfurterdashboard.onrender.com/rates-from-db')
            .then((res) => res.json())
            .then((data) => {
                setRowData(data);
            })
            .catch((err) => console.error('Error fetching data:', err));
    }, []);

    const chartData = React.useMemo(() => {
        //Data Sets
        const USD_EUR = rowData.filter(
          (d) => d.base === 'USD' && d.target === 'EUR',
        );
        const USD_CAD = rowData.filter(
          (d) => d.base === 'USD' && d.target === 'CAD',
        );
        const EUR_CAD = rowData.filter(
          (d) => d.base === 'EUR' && d.target === 'CAD',
        );
    
        //Sort Data Sets
        USD_EUR.sort((a, b) => new Date(a.date) - new Date(b.date));
        USD_CAD.sort((a, b) => new Date(a.date) - new Date(b.date));
        EUR_CAD.sort((a, b) => new Date(a.date) - new Date(b.date));
    
        return {
          labels: USD_EUR.map((d) => d.date),
          datasets: [
            {
              label: 'USD to EUR',
              data: USD_EUR.map((d) => d.rate),
              borderColor: 'rgb(0, 255, 0)',
              backgroundColor: 'rgb(0, 255, 0)',
              tension: 0.2,
            },
            {
              label: 'EUR to USD',
              data: USD_EUR.map((d) => d.reverse_rate),
              borderColor: 'rgb(239, 3, 3)',
              backgroundColor: 'rgb(239, 3, 3)',
              tension: 0.2,
            },
            {
              label: 'USD to CAD',
              data: USD_CAD.map((d) => d.rate),
              borderColor: 'rgb(22, 9, 172)',
              backgroundColor: 'rgb(22, 9, 172)',
              tension: 0.2,
            },
            {
              label: 'CAD to USD',
              data: USD_CAD.map((d) => d.reverse_rate),
              borderColor: 'rgb(187, 2, 181)',
              backgroundColor: 'rgb(187, 2, 181)',
              tension: 0.2,
            },
            {
              label: 'CAD to EUR',
              data: EUR_CAD.map((d) => d.reverse_rate),
              borderColor: 'rgb(6, 156, 151)',
              backgroundColor: 'rgb(6, 156, 151)',
              tension: 0.2,
            },
            {
              label: 'EUR to CAD',
              data: EUR_CAD.map((d) => d.rate),
              borderColor: 'rgb(246, 254, 0)',
              backgroundColor: 'rgb(246, 254, 0)',
              tension: 0.2,
            }
          ],
        };
      }, [rowData]);

      return (
        <div style={{ 
            width: '90%', 
            margin: 'auto',
            padding: '2rem',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)',
            border: '1px solid #e2e8f0',
          }}>
          <h2>Exchange Rate Graph</h2>
          <Line data={chartData} />
        </div>
      );
}

export default Graph;
